var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMissing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3525 9.95988C19.3525 14.849 15.3892 18.8123 10.5 18.8123C5.6109 18.8123 1.64758 14.849 1.64758 9.95988C1.64758 5.07074 5.6109 1.10742 10.5 1.10742C15.3892 1.10742 19.3525 5.07074 19.3525 9.95988Z",
    fill: "#FF9416"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12.5357,
    height: 2.55583,
    rx: 1.27792,
    transform: "matrix(0.707107 -0.707106 0.707107 0.707106 5.21277 13.5684)",
    fill: "#FFFDFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissing);
export default __webpack_public_path__ + "static/media/missing.b5681b4243124722d0cdade37fb0772c.svg";
export { ForwardRef as ReactComponent };